import React from 'react';
import { HeroSection } from './components/HeroSection';
import { ProblemSection } from './components/ProblemSection';
import { EmotionalIdentificationSection } from './components/EmotionalIdentificationSection';
import { CycleSection } from './components/CycleSection';
import { ProductIntroSection } from './components/ProductIntroSection';
import { LevelsSection } from './components/LevelsSection';
import { BonusSection } from './components/BonusSection';
import { WhyWorksSection } from './components/WhyWorksSection';
import { ComparisonSection } from './components/ComparisonSection';
import { ResultsSection } from './components/ResultsSection';
import { ForWhoSection } from './components/ForWhoSection';
import { OfferSection } from './components/OfferSection';
import { FinalCTASection } from './components/FinalCTASection';
import { SocialProofSection } from './components/SocialProofSection';
import { GuaranteeSection } from './components/GuaranteeSection';
import { TransformationSection } from './components/TransformationSection';
import { MiniTestimonial } from './components/MiniTestimonial';
import { TestimonialsSection } from './components/TestimonialsSection';
import { MockupSection } from './components/MockupSection';
import { InlineCTA } from './components/InlineCTA';
export function App() {
  return <div className="w-full min-h-screen bg-[#0a0a0a] text-white" data-id="element-0">
      {/* HOOK */}
      <HeroSection data-id="element-1" />

      {/* PROBLEM AWARENESS & IDENTIFICATION */}
      <ProblemSection data-id="element-2" />
      <EmotionalIdentificationSection data-id="element-3" />
      <CycleSection data-id="element-4" />

      {/* PRODUCT REVEAL */}
      <MockupSection data-id="element-5" />
      <ProductIntroSection data-id="element-6" />

      <MiniTestimonial quote="Lo que más me ayudó fue dejar de vivir pendiente de si iba a fallar. Recuperé la tranquilidad y pude volver a disfrutar de mis relaciones." name="Tomás" age={31} data-id="element-7" />

      <BonusSection data-id="element-8" />

      {/* RESULTADOS + TRANSFORMACIÓN */}
      <ResultsSection data-id="element-9" />
      <TransformationSection data-id="element-10" />

      {/* SOCIAL PROOF */}
      <SocialProofSection data-id="element-11" />
      <TestimonialsSection data-id="element-12" />

      {/* REFUERZO */}
      <WhyWorksSection data-id="element-13" />
      <ComparisonSection data-id="element-14" />
      <ForWhoSection data-id="element-15" />

      {/* OFERTA Y GARANTÍA */}
      <GuaranteeSection data-id="element-16" />
      <OfferSection data-id="element-17" />

      {/* CIERRE */}
      <FinalCTASection data-id="element-18" />
    </div>;
}